import { QuoteTemplateLineItem } from '../models/quote-template';
import { QuoteLineItem } from '../models/quote';

export interface HasQuoteTemplateLineItems {
  lineItems?: QuoteTemplateLineItem[];
}

export interface HasQuoteLineItems {
  lineItems?: QuoteLineItem[];
}

export type HasLineItems = HasQuoteTemplateLineItems | HasQuoteLineItems;

function isQuoteTemplateLineItem(lineItem: QuoteTemplateLineItem | QuoteLineItem): lineItem is QuoteTemplateLineItem {
  return 'ntitype' in lineItem;
}

function isQuoteLineItem(lineItem: QuoteTemplateLineItem | QuoteLineItem): lineItem is QuoteLineItem {
  return 'jrptype' in lineItem;
}

export function transformIncomingLineItemTypes<T extends HasLineItems>(entity: T): T {
  entity.lineItems?.forEach(lineItem => {
    if (isQuoteTemplateLineItem(lineItem) && lineItem.ntitype === 'Prod/Serv') {
      lineItem.ntitype = 'Product';
    } else if (isQuoteLineItem(lineItem) && lineItem.jrptype === 'Prod/Serv') {
      lineItem.jrptype = 'Product';
    }

    if(isQuoteTemplateLineItem(lineItem) && !lineItem.ntitrackingid) {
      lineItem.ntitrackingid = crypto.randomUUID() + `${lineItem.ntitype === "GroupEnd" ? "-end" : ""}`;
    }
    if(isQuoteLineItem(lineItem) && !lineItem.jrptrackingid) {
      lineItem.jrptrackingid = crypto.randomUUID() + `${lineItem.jrptype === "GroupEnd" ? "-end" : ""}`;
    }
  });
  return entity;
}

export function transformOutgoingLineItemTypes<T extends HasLineItems>(entity: T): T {
  entity.lineItems?.forEach(lineItem => {
    if (isQuoteTemplateLineItem(lineItem) && (lineItem.ntitype === 'Product' || lineItem.ntitype === 'Service')) {
      lineItem.ntitype = 'Prod/Serv';
    } else if (isQuoteLineItem(lineItem) && (lineItem.jrptype === 'Product' || lineItem.jrptype === 'Service')) {
      lineItem.jrptype = 'Prod/Serv';
    }
  });
  return entity;
} 
